import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { FileUploadType } from '../services/backendService/types';
import { generateUniqueId } from '../utils/general';

export const useUploadGenericFile = (tenantId: string) => {
  const client = useQueryClient();
  const { mutate: upload, error, isLoading, isSuccess, data, reset } = useMutation(
    async ({ file, fileType }: { file: File; fileType: FileUploadType }) => {
      const fileId = generateUniqueId().toString();

      const data = await BackendService.instance.getUploadUrlV2({
        pathToFile: `game_files/${fileId}`, // this could be a problem for passages, I can't remember rn whether passage paths are different
        fileType,
        mimeType: file.type,
        fileName: file.name,
        tenantId,
      });

      const url = data.data.url;

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', url, true);
        xhr.setRequestHeader('Content-Type', file.type);

        xhr.onreadystatechange = function() {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(fileId);
            } else {
              reject(xhr.response);
            }
          }
        };
        xhr.onerror = function(response) {
          reject(response);
        };
        xhr.send(file);
      });
      await BackendService.instance.markUploadSuccessfulV2(data.data.uploadId, tenantId);
      return Promise.resolve({
        fileUploadId: data.data.uploadId,
        fileName: file.name,
        mimetype: file.type,
        fileId,
      });
    },
    {
      onSuccess: () => {
        client.invalidateQueries(['uploadedDesignerImage']);
      },
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    error: error,
    data,
    reset,
  };
};
